'use client'

import { PageError } from '@/components/app/PageError'
import { NextErrorParams } from '@/types'

export default function Error({ error, reset }: NextErrorParams) {
    return <PageError error={error} reset={reset} location="auth" />
}
